module.exports = __webpack_public_path__ + "img/nrt.5757ea15.png";